import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Creator } from '@/types';

async function fetchAllLeads(collectorId: string): Promise<Creator[]> {
  const all: Creator[] = [];
  let page = 1;
  let hasMore = true;
  while (hasMore) {
    const batch = await pb.collection('leads').getList<Creator>(page, 200, {
      filter: `collector = "${collectorId}"`,
      sort: '-created',
    });
    all.push(...batch.items);
    hasMore = batch.totalPages > page;
    page++;
  }
  return all;
}

export function useCollectorCreators(collectorId: string | undefined) {
  return useQuery({
    queryKey: ['collector-creators-all', collectorId],
    queryFn: () => fetchAllLeads(collectorId!),
    enabled: !!collectorId,
    staleTime: 60_000,
  });
}
